import AnnualSummaryError from './AnnualSummaryError';
class AnnualSummaryPropertyNotFound extends AnnualSummaryError {
    propertyId;
    constructor(propertyId, options) {
        super('Crowdfunding property was not found with the received id', options);
        this.propertyId = propertyId;
    }
}
export default AnnualSummaryPropertyNotFound;
